import { render, staticRenderFns } from "./BillsOfMaterialsForm.vue?vue&type=template&id=109b4fd3&scoped=true&"
import script from "./BillsOfMaterialsForm.vue?vue&type=script&lang=js&"
export * from "./BillsOfMaterialsForm.vue?vue&type=script&lang=js&"
import style0 from "./BillsOfMaterialsForm.vue?vue&type=style&index=0&id=109b4fd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109b4fd3",
  null
  
)

export default component.exports